/**
 * `/app/widgets/$widgetRef/connect` — how the client's site connects to a widget the
 * portal hosts: its keys, its settings, the requests it makes, its site hooks and, for
 * a blog, the author directory (`.docs/46-blog-and-forms.md` §7, "Connect").
 *
 * A sibling of the widget's own page and of its workspace, under the widget's address
 * (`$widgetRef/index.tsx` says why that is an index). The page is
 * `pages/connect/ConnectPage.tsx` over the client's port; the studio mounts the same
 * page at `/studio/clients/$slug/connect/$widgetRef`.
 */

import { createFileRoute } from '@tanstack/react-router'

import { NotFound } from '../../../../errors/NotFound.js'
import { ClientConnectPage } from '../../../../pages/connect/ClientConnectPage.js'
import { parseConnectSearch } from '../../../../pages/connect/search.js'

export const Route = createFileRoute('/app/widgets/$widgetRef/connect')({
  /** `?example=curl|fetch` — how the examples are written, which the page writes. */
  validateSearch: parseConnectSearch,
  /** R3-13: a refusal under this route keeps the portal around it. */
  notFoundComponent: NotFound,
  component: ConnectRoute,
})

function ConnectRoute() {
  const { widgetRef } = Route.useParams()
  return <ClientConnectPage widgetRef={widgetRef} />
}
